namespace TabAurous.ProductDevelopment {
    export interface CustomerRequirementItemsRow {
        TransItemId?: number;
        TransId?: number;
        LedgerName?: string;
        PartyCode?: string;
        PartyId?: number;
        RefNo?: string;
        Iteration?: string;
        CategoryId?: number;
        SubCategoryId?: number;
        MetalName?: string;
        MetalId?: number;
        KaratId?: number;
        ProductSizeId?: number;
        MetalColorId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        CenterStone?: number;
        StoneCategoryId?: number;
        StoneSubCategoryId?: number;
        DualToneMetalId?: number;
        DualToneKaratId?: number;
        DualToneMetalColorId?: number;
        DualTonePurity?: number;
        TripleToneMetalId?: number;
        TripleToneKaratId?: number;
        TripleToneMetalColorId?: number;
        TripleTonePurity?: number;
        TripleToneKarat?: string;
        DualToneKarat?: string;
        MappingId?: number;
        Budget?: number;
        ImageName?: string;
        Image1?: string;
        Image2?: string;
        Image3?: string;
        Image4?: string;
        Image5?: string;
        StoneItems?: CustomerRequirementStoneItemsRow[];
        UserId?: number;
        ToneType?: Common.ToneType;
        Remark?: string;
        SpecialRemark?: string;
        StatusId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        Lab?: string;
        ItemTypeId?: number;
        ProductTypeId?: number;
        BOMDetails?: CustomerRequirementBOMRow[];
        VoucherTypeId?: number;
        VoucherDate?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        MFAmount?: number;
        MF?: number;
        ExportPieces?: number;
        HUID?: string;
        StampId?: number;
        StockAllocation?: boolean;
        StoneRate?: number;
        OtherRate?: number;
        FancyCharges?: number;
        OtherCharges?: number;
        HasBom?: boolean;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        Attribute?: string;
        CalcUnitId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        Rate?: number;
        ServerDate?: string;
        Remarks?: string;
        DiscountPer?: number;
        IsDisabled?: boolean;
        AttributeId?: number;
        HSN?: string;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        Parts?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        CalcOnId?: number;
        UnitRate?: number;
        UnitLabour?: number;
        UnitCost?: number;
        NetAmount?: number;
        Discount?: number;
        GrossAmount?: number;
        RefTransItemId?: number;
        RefTransId?: number;
        UserDescription?: string;
        AckStatus?: number;
        DeliveryDate?: string;
        CompanyId?: number;
        BagStatus?: string;
        WstPer?: number;
        WstWt?: number;
        Purity?: number;
        PureWeight?: number;
        DeptName?: string;
        DesignId?: number;
        DesignCode?: string;
        BrandId?: number;
        SuperTypeId?: number;
        CollectionId?: number;
        CostMethodId?: Common.CostMethod;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        ProductId?: number;
        ProductCode?: string;
        ProductName?: string;
        TaxCode?: string;
    }

    export namespace CustomerRequirementItemsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'ProductName';
        export const localTextPrefix = 'ProductDevelopment.CustomerRequirementItems';
        export const deletePermission = 'ProductDevelopment:CustomerRequirement:Delete';
        export const insertPermission = 'ProductDevelopment:CustomerRequirement:Add';
        export const readPermission = '*';
        export const updatePermission = 'ProductDevelopment:CustomerRequirement:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            LedgerName = "LedgerName",
            PartyCode = "PartyCode",
            PartyId = "PartyId",
            RefNo = "RefNo",
            Iteration = "Iteration",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            MetalName = "MetalName",
            MetalId = "MetalId",
            KaratId = "KaratId",
            ProductSizeId = "ProductSizeId",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            CenterStone = "CenterStone",
            StoneCategoryId = "StoneCategoryId",
            StoneSubCategoryId = "StoneSubCategoryId",
            DualToneMetalId = "DualToneMetalId",
            DualToneKaratId = "DualToneKaratId",
            DualToneMetalColorId = "DualToneMetalColorId",
            DualTonePurity = "DualTonePurity",
            TripleToneMetalId = "TripleToneMetalId",
            TripleToneKaratId = "TripleToneKaratId",
            TripleToneMetalColorId = "TripleToneMetalColorId",
            TripleTonePurity = "TripleTonePurity",
            TripleToneKarat = "TripleToneKarat",
            DualToneKarat = "DualToneKarat",
            MappingId = "MappingId",
            Budget = "Budget",
            ImageName = "ImageName",
            Image1 = "Image1",
            Image2 = "Image2",
            Image3 = "Image3",
            Image4 = "Image4",
            Image5 = "Image5",
            StoneItems = "StoneItems",
            UserId = "UserId",
            ToneType = "ToneType",
            Remark = "Remark",
            SpecialRemark = "SpecialRemark",
            StatusId = "StatusId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            Lab = "Lab",
            ItemTypeId = "ItemTypeId",
            ProductTypeId = "ProductTypeId",
            BOMDetails = "BOMDetails",
            VoucherTypeId = "VoucherTypeId",
            VoucherDate = "VoucherDate",
            RefVoucherId = "RefVoucherId",
            DepartmentId = "DepartmentId",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount",
            MFAmount = "MFAmount",
            MF = "MF",
            ExportPieces = "ExportPieces",
            HUID = "HUID",
            StampId = "StampId",
            StockAllocation = "StockAllocation",
            StoneRate = "StoneRate",
            OtherRate = "OtherRate",
            FancyCharges = "FancyCharges",
            OtherCharges = "OtherCharges",
            HasBom = "HasBom",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            Attribute = "Attribute",
            CalcUnitId = "CalcUnitId",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            Rate = "Rate",
            ServerDate = "ServerDate",
            Remarks = "Remarks",
            DiscountPer = "DiscountPer",
            IsDisabled = "IsDisabled",
            AttributeId = "AttributeId",
            HSN = "HSN",
            Studded = "Studded",
            Pieces = "Pieces",
            Weight = "Weight",
            Parts = "Parts",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            MetalAmount = "MetalAmount",
            DiamondAmount = "DiamondAmount",
            StoneAmount = "StoneAmount",
            OtherAmount = "OtherAmount",
            CalcOnId = "CalcOnId",
            UnitRate = "UnitRate",
            UnitLabour = "UnitLabour",
            UnitCost = "UnitCost",
            NetAmount = "NetAmount",
            Discount = "Discount",
            GrossAmount = "GrossAmount",
            RefTransItemId = "RefTransItemId",
            RefTransId = "RefTransId",
            UserDescription = "UserDescription",
            AckStatus = "AckStatus",
            DeliveryDate = "DeliveryDate",
            CompanyId = "CompanyId",
            BagStatus = "BagStatus",
            WstPer = "WstPer",
            WstWt = "WstWt",
            Purity = "Purity",
            PureWeight = "PureWeight",
            DeptName = "DeptName",
            DesignId = "DesignId",
            DesignCode = "DesignCode",
            BrandId = "BrandId",
            SuperTypeId = "SuperTypeId",
            CollectionId = "CollectionId",
            CostMethodId = "CostMethodId",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            TaxCode = "TaxCode"
        }
    }
}
